import { useQuery } from "@tanstack/react-query"

import { getTranscriptionStatus } from "~/api/files"
import useGlobalStore from "~/store/global"
import { ITokenInfo } from "~/types/global"

export function useTranscriptionStatus(fileIds: string[], enabled: boolean) {
  const tokenInfo = useGlobalStore((store) => store.tokenInfo)
  return useQuery({
    queryKey: ["transcription-status", fileIds.slice().sort().join(",")],
    queryFn: async () => {
      if (fileIds.length === 0) return { files: [] }
      const res = await getTranscriptionStatus(tokenInfo as ITokenInfo, fileIds)
      return res.data?.data ?? { files: [] }
    },
    enabled: !!tokenInfo && enabled && fileIds.length > 0,
    refetchInterval: (q) => {
      const data = q.state.data as
        | { files: { transcription_status: string }[] }
        | undefined
      const hasPending = data?.files?.some(
        (f) => f.transcription_status === "pending"
      )
      return hasPending ? 5000 : false
    }
  })
}
